import * as React from 'react'

export const InfoIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.08325 5.41671H10.9166V7.25004H9.08325V5.41671ZM9.08325 9.08337H10.9166V14.5834H9.08325V9.08337ZM9.99992 0.833374C4.93992 0.833374 0.833252 4.94004 0.833252 10C0.833252 15.06 4.93992 19.1667 9.99992 19.1667C15.0599 19.1667 19.1666 15.06 19.1666 10C19.1666 4.94004 15.0599 0.833374 9.99992 0.833374ZM9.99992 17.3334C5.95742 17.3334 2.66659 14.0425 2.66659 10C2.66659 5.95754 5.95742 2.66671 9.99992 2.66671C14.0424 2.66671 17.3333 5.95754 17.3333 10C17.3333 14.0425 14.0424 17.3334 9.99992 17.3334Z"
        fill="#0288d1"
      />
    </svg>
  )
}
